import React from "react";
import "./SplashScreen.css";

const SplashScreen = () => {
  return <div className="splash-screen"></div>;
};

export default SplashScreen;
